<template>
    <div class="flex gap-2 items-center justify-center at720:justify-between">
        <div class="hidden at720:flex at720:gap-2">
            <button
                @click="navigate(data.prev_page_url)"
                :disabled="!data.prev_page_url"
                class="btn-black-on-gray-pill dark:bg-gray-850 dark:group-hover:bg-gray-900"
                v-if="data.prev_page_url"
            >
                <BaseSvg name="icon-trending-flat-right" class="rotate-180" aria-hidden="true" />
                <span aria-hidden="true">{{ $t('Prev') }}</span>
                <span class="sr-only">{{ $t('Previous page') }}</span>
            </button>
            <button
                @click="navigate(data.next_page_url)"
                :disabled="!data.next_page_url"
                class="btn-black-on-gray-pill dark:bg-gray-850 dark:group-hover:bg-gray-900"
                v-if="data.next_page_url"
            >
                {{ $t('Next') }}<span class="sr-only"> {{ $t('page') }}</span>
                <BaseSvg name="icon-trending-flat-right" aria-hidden="true" />
            </button>
        </div>
        <div class="flex gap-1">
            <button
                @click="navigate(data.first_page_url)"
                class="duration-150 text-xs w-8 h-8 rounded-full bg-gray-125 hover:bg-gray-150 active:bg-gray-175 active:scale-95 dark:bg-gray-850 dark:hover:bg-gray-900"
                v-if="data.prev_page_url && data.prev_page_url !== data.first_page_url"
            >
                <BaseSvg name="icon-double-chevron-left" class="-translate-x-px" aria-hidden="true" />
                <span class="sr-only">{{ $t('First page') }}</span>
            </button>
            <button
                @click="navigate(data.prev_page_url)"
                :disabled="!data.prev_page_url"
                class="duration-150 text-xs w-8 h-8 rounded-full bg-gray-125 hover:bg-gray-150 active:bg-gray-175 active:scale-95 dark:bg-gray-850 dark:hover:bg-gray-900"
                v-if="data.prev_page_url"
            >
                <BaseSvg name="icon-chevron-left" class="-translate-x-px" aria-hidden="true" />
                <span class="sr-only">{{ $t('Previous page') }}</span>
            </button>
            <button
            v-for="page in limitedPages" :key="page"
                @click="navigate(page.url)"
                :class="{
                    '!bg-gray-tier-1 text-white': data.current_page === page.number || page.url === isLoading,
                }"
                :aria-current="data.current_page === page.number || page.url === isLoading ? 'page' : ''"
                class="duration-150 text-xs w-8 h-8 rounded-full bg-gray-125 hover:bg-gray-150 active:bg-gray-175 active:scale-95 dark:bg-gray-850 dark:hover:bg-gray-900"
            >
                <span class="sr-only">{{ $t('Page') }} </span>{{ page.number }}
            </button>
            <button
                @click="navigate(data.next_page_url)"
                :disabled="!data.next_page_url"
                 class="duration-150 text-xs w-8 h-8 rounded-full bg-gray-125 hover:bg-gray-150 active:bg-gray-175 active:scale-95 dark:bg-gray-850 dark:hover:bg-gray-900"
                v-if="data.next_page_url"
            >
                <BaseSvg name="icon-chevron-right" class="translate-x-px" aria-hidden="true" />
                <span class="sr-only">{{ $t('Next page') }}</span>
            </button>
            <button
                @click="navigate(data.last_page_url)"
                :disabled="!data.next_page_url"
                 class="duration-150 text-xs w-8 h-8 rounded-full bg-gray-125 hover:bg-gray-150 active:bg-gray-175 active:scale-95 dark:bg-gray-850 dark:hover:bg-gray-900"
                v-if="data.next_page_url"
            >
                <BaseSvg name="icon-double-chevron-right" class="translate-x-px" aria-hidden="true" />
                <span class="sr-only">{{ $t('Last page') }}</span>
            </button>
        </div>
    </div>
</template>

<script setup>
import {ref, watchEffect} from 'vue';
import { router } from "@inertiajs/vue3";
import { BaseSvg } from "@/Components";

const props = defineProps(['data']);

const limitedPages = ref([]);
const isLoading = ref(null);

watchEffect(() => {
    const range = [];
    const current = props.data.current_page - 3;
    const last = props.data.last_page;
    const limit = 6; // Show next 4 numbers

    const startPage = Math.max(current, 1);
    const endPage = Math.min(current + limit, last);

    for (let i = startPage; i <= endPage; i++) {
        range.push({
            url: `${props.data.path}?page=${i}`,
            number: i
        });
    }

    limitedPages.value = range;
});

const navigate = (url) => {
    isLoading.value = url;
    console.log('isLoading.value', isLoading.value);
    if (url) {
        router.visit(url);
    }
};
</script>
